<template>
  <button
    id="start"
    @click="onClick"
  >
    <div>Start</div>
    <svg width="12px" height="19px" viewBox="0 0 12 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
            <g id="RetVejkode-Home" transform="translate(-1316.000000, -221.000000)" stroke="#8954BA" stroke-width="2">
                <g id="Group-3" transform="translate(1187.000000, 196.000000)">
                    <path d="M130,42.5891513 C136.028257,37.2611121 139.042385,34.5970925 139.042385,34.5970925 C139.042385,34.5970925 137.802826,33.4185757 135.323708,31.0615421 C134.399223,30.1825835 132.624654,28.4954028 130,26" id="Line-9"></path>
                </g>
            </g>
        </g>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'StartButton',
  props: {
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
button {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 70px;
  width: 170px;
  background: #FFFFFF;
  font-weight: 600;
  font-size: 22px;
  cursor: pointer;
  border: none;
  border-radius: 6px;
  text-decoration: none;
  color: $default-color;
  box-shadow: 0 2px 30px 0 rgba(53,8,112,0.29);
  text-transform: uppercase;
  transition: $transition-length;
}

button:hover {
  background: $default-color-background-light;
}
</style>
